import { Helper } from '../../helper/helper';
import { Changelog } from '../../types';
import { 
    BadgeBlue, 
    BadgeGreen, 
    BadgeYellow, 
    ChangelogBadgesContainer, 
    ChangelogContainer, 
    ChangelogDot, 
    ChangelogItemContainer, 
    ChangelogLinesContainer, 
    ChangelogSeparator, 
    ChangelogTime, 
    ChangelogTitle, 
    ChangelogULList, 
    ChangelogVersion 
} from './Changelogs.styled';

const ChangelogsListItem = ({ index, data }: { index: number, data: Changelog }) => {
    return (
        <ChangelogItemContainer key={index}>
            <ChangelogVersion $index={index}>V {data.version}</ChangelogVersion>
            <ChangelogLinesContainer>
                {index === 0 && <ChangelogDot />}
                <ChangelogSeparator $index={index} />
            </ChangelogLinesContainer>
            <ChangelogContainer>
                <ChangelogTitle $index={index}>
                    <ChangelogBadgesContainer>
                        {data.labels?.includes('new') && <BadgeBlue>New</BadgeBlue>}
                        {data.labels?.includes('fix') && <BadgeGreen>Fix</BadgeGreen>}
                        {data.labels?.includes('improvement') && <BadgeYellow>Improvement</BadgeYellow>}
                    </ChangelogBadgesContainer>
                    <ChangelogTime>{Helper.relativeDate(data.date)}</ChangelogTime>
                </ChangelogTitle>
                <ChangelogULList $index={index}>
                    {data.content.split("\n").map((line, index) => (
                        <li key={index}>{line.startsWith('-') ? line.slice(1) : line}</li>
                    ))}
                </ChangelogULList>
            </ChangelogContainer>
        </ChangelogItemContainer>
    );
};

export default ChangelogsListItem;
